import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class Difficulty extends Cloneable {

    static _values = [
        new Difficulty(0, "NONE"),
        new Difficulty(1, "EASY"),
        new Difficulty(2, "MEDIUM"),
        new Difficulty(3, "HARD"),
    ];

    static getValues() {
        return Difficulty._values;
    }

    static getValue(id) {
        let value = Difficulty._values.find(v => v.id === id) || null;
        console.assert(value, "unknown value: " + id);
        return value;
    }

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, Difficulty.getValue(id));
        });
    }

    static is(value) {
        if (value instanceof Difficulty) {
            return Difficulty._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    constructor(id = 0, name = "None") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    equal(value) {
        if (value instanceof Difficulty) {
            return this.id === value.id;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new Difficulty());
        } else if (target instanceof Difficulty) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(Difficulty, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});